import React from "react";
import { ArrowLeft, Phone, Mail, MapPin } from "lucide-react";

const PHONE_DISPLAY = "030 34762216";
const PHONE_TEL = "+493034762216";

const LegalPageLayout = ({ title, intro, children }) => {
  return (
    <div className="bg-background min-h-screen flex flex-col" data-testid="legal-page">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
          <a href="/" className="flex items-center" data-testid="legal-brand-logo">
            <img
              src="/brand/rodex-logo.svg"
              alt="Rodex Berlin Logo"
              className="h-9 sm:h-10 w-auto block"
            />
          </a>
          <a
            href="/"
            className="flex items-center gap-1.5 text-sm text-charcoal hover:text-brand-orange font-medium transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            <span className="hidden sm:inline">Zur Startseite</span>
            <span className="sm:hidden">Zurück</span>
          </a>
        </div>
      </header>

      {/* Hero */}
      <section className="bg-charcoal text-white py-14 sm:py-20 relative overflow-hidden">
        <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
        <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[400px] h-[400px] bg-brand-orange/10 blur-3xl rounded-full pointer-events-none" />
        <div className="relative max-w-5xl mx-auto px-5 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-3" data-testid="legal-title">
            {title}
          </h1>
          {intro && <p className="text-white/70 text-sm sm:text-base max-w-2xl">{intro}</p>}
        </div>
      </section>

      {/* Content */}
      <main className="flex-1 py-12 sm:py-16">
        <article
          className="max-w-3xl mx-auto px-5 lg:px-8 text-slate-700 leading-relaxed text-sm sm:text-base space-y-6
                     [&_h2]:text-xl [&_h2]:sm:text-2xl [&_h2]:font-bold [&_h2]:text-charcoal [&_h2]:mt-10 [&_h2]:mb-3
                     [&_h3]:text-base [&_h3]:sm:text-lg [&_h3]:font-semibold [&_h3]:text-charcoal [&_h3]:mt-6 [&_h3]:mb-2
                     [&_p]:leading-relaxed
                     [&_a]:text-brand-orange [&_a]:underline [&_a]:underline-offset-2
                     [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5
                     [&_strong]:text-charcoal"
          data-testid="legal-content"
        >
          {children}
        </article>
      </main>

      {/* Footer */}
      <footer className="bg-charcoal-deep text-white/70 border-t border-white/5">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 py-10 grid sm:grid-cols-2 gap-6 text-sm">
          <div>
            <img src="/brand/rodex-logo.svg" alt="Rodex Berlin Logo" className="h-10 w-auto mb-3 block" />
            <p className="text-xs leading-relaxed">
              Spezialist für Nagetierbekämpfung in Berlin.
            </p>
          </div>
          <div className="space-y-1.5 text-xs">
            <div className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-brand-orange" /> <a href={`tel:${PHONE_TEL}`} className="hover:text-white">{PHONE_DISPLAY}</a></div>
            <div className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-brand-orange" /> <a href="mailto:info@rodex.berlin" className="hover:text-white">info@rodex.berlin</a></div>
            <div className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-brand-orange" /> Berlin</div>
            <div className="pt-3 flex flex-wrap gap-3 text-[11px]">
              <a href="/impressum" className="hover:text-white">Impressum</a>
              <a href="/datenschutz" className="hover:text-white">Datenschutz</a>
              <a href="/agb" className="hover:text-white">AGB</a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/5 py-4 text-center text-[11px] text-white/40">
          © 2025 Rodex Berlin — Alle Rechte vorbehalten.
        </div>
      </footer>
    </div>
  );
};

export default LegalPageLayout;
